/* 🤖 this file was generated by script */
export const wiconChecklist = {
  name: 'checklist',
  data: `<svg viewBox="0 0 20 20"><circle cx="7" cy="13" r="1" fill="currentColor"/><path fill="none" stroke="currentColor" stroke-linecap="round" d="M11 13.03h3.01M11 8h3.01m-8.53-.56L6.8 8.75 9.54 6"/><rect width="14.02" height="14" x="2.99" y="2.97" fill="none" stroke="currentColor" stroke-width="1.5" rx="1"/></svg>`,
};
